import {ProcedureParameterConfirmationMethod} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * Most procedure configuration tables have a "data type" column, which acts as a selector for
 * what type of data will be accepted. It's essentially a schema field type configurator.
 *
 * Each table type curates a slightly different list of options. For example, a data parameter
 * can only be text or float, while material inputs can be an entity schema link.
 *
 * This "context" is used to configure the column definition, which in turn is used to configure
 * the dropdown selector inside the appropriate table cell.
 */
export enum ProcedureSchemaFieldTypeContext {
  MATERIAL_INPUT = 'MATERIAL_INPUT',
  MATERIAL_OUTPUT = 'MATERIAL_OUTPUT',
  DATA_PARAMETER = 'DATA_PARAMETER',
  EQUIPMENT = 'EQUIPMENT',
}

export const CONFIRMATION_METHOD_TO_USER_FACING_TEXT: Record<ProcedureParameterConfirmationMethod, string> = {
  [ProcedureParameterConfirmationMethod.TABLE]: 'Table',
  [ProcedureParameterConfirmationMethod.PLATE_MAP]: 'Plate map',
};

export const USER_FACING_TEXT_TO_CONFIRMATION_METHOD: Record<string, ProcedureParameterConfirmationMethod> =
  Object.fromEntries(
    Object.entries(CONFIRMATION_METHOD_TO_USER_FACING_TEXT).map(([k, v]) => [
      v,
      k as ProcedureParameterConfirmationMethod,
    ])
  );

// Store column names for the test definitions table here instead of in the
// TestDefinitionsTableAdapter to avoid circular dependencies between
// TestDefinitionsTableAdapter and ProcedureTestDefinitionCustomEvals.
export enum TestDefinitionsTableColumn {
  TEST = 'TEST',
  DESCRIPTION = 'DESCRIPTION',
  RESULT_SCHEMA = 'RESULT_SCHEMA',
}
